export default "__VITE_ASSET__QNyzKTsR__"